(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 56413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTickGreen = function SvgTickGreen(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M5.084 13c.466 0 .823-.194 1.071-.581l6.59-10.535a1.69 1.69 0 0 0 .196-.412c.04-.132.059-.26.059-.385 0-.318-.101-.58-.304-.782A1.05 1.05 0 0 0 11.92 0c-.218 0-.4.044-.545.131-.145.088-.287.24-.427.46l-5.9 9.69-3.042-4.057c-.248-.313-.55-.47-.908-.47-.32 0-.584.104-.79.31C.104 6.27 0 6.536 0 6.861c0 .144.024.283.073.417.048.134.133.273.254.417l3.686 4.752c.29.369.647.553 1.07.553Z",
    fill: "#1BA287"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgTickGreen);

/***/ }),

/***/ 8738:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(63841);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96321:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/clock.b30d2d16.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEUaoYZMaXEaoYYaoYYaoYYaoYYaoYYaoYYaoYaRdehPAAAACXRSTlNwAEsYgiQMAjozGGDOAAAACXBIWXMAACE4AAAhOAFFljFgAAAAMUlEQVQImR2LyQ3AQAyEwGf/HW+ckUB8Btd/rA2h2BVBiGRjzcVWkxh4nAvmwsnv/gAS+QCCJA2ouwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 74939:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/pin.0b606da5.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEVMaXFUVFRUVFRUVFRUVFRUVFRUVFRUVFTKrMONAAAACHRSTlMAg0kYWDBnaULew2gAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAuSURBVAiZRYrJDQAgEISY2cP+OzauMfLhAfCJXjWWrQCckhOodqZPU4XurVkeGw2XAFa9+KH7AAAAAElFTkSuQmCC"});

/***/ }),

/***/ 68358:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/forest-book.cbd52c69.png","height":240,"width":180,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAASFBMVEU3UlYnRksvUT0UODk2UVEZRkM5UlJIaT1EYlQwTUopTEk/WVtCXVwXP0AZPz0WPDoTNjgSNzsUOzsbQkA9VlNPZ2YsSU85WU57X+OoAAAAE3RSTlP+3t+k0v21/v7iu+TV3Oi/6NzCIoJ5fAAAAAlwSFlzAAALEwAACxMBAJqcGAAAADdJREFUCJkFwQkCgCAIAMFVQcDusPr/T5uhryLSWR7mDMoLFMLdv6CamVW2VNWLPTPzpB1j3O0HLkcB1OfiW0IAAAAASUVORK5CYII="});

/***/ }),

/***/ 63841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ../../node_modules/tailwind-styled-components/dist/index.js
var dist = __webpack_require__(17471);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../core/src/components/Button.tsx
var Button = __webpack_require__(36573);
;// CONCATENATED MODULE: ../core/src/components/SectionDesc.tsx





var SectionDesc = function(param) {
    var sectionTitle = param.sectionTitle, title = param.title, icon = param.icon, info = param.info, _className = param.className, className = _className === void 0 ? '' : _className, onClick = param.onClick;
    var t = (0,esm/* useTranslation */.$G)('common').t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col ".concat(className),
        children: [
            icon && sectionTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row mb-4 md:mb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mr-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            src: icon,
                            width: 16,
                            height: 16
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-black font-poppins font-bold uppercase text-sm md:text-base",
                        children: sectionTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-2xl md:text-4xl text-black font-poppins mb-4 leading-snug",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-gray-700 text-sm md:text-lg leading-6 md:leading-8 max-w-3xl mb-6",
                children: info
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                title: t('nav.signUpFree'),
                value: "section-sign-up",
                onClick: onClick
            })
        ]
    }));
};

// EXTERNAL MODULE: ../core/src/components/SvgIcon.tsx
var SvgIcon = __webpack_require__(16283);
// EXTERNAL MODULE: ../core/src/components/ResponsiveImage.tsx
var ResponsiveImage = __webpack_require__(17094);
// EXTERNAL MODULE: ../assets/icons/tick-green.svg
var tick_green = __webpack_require__(56413);
;// CONCATENATED MODULE: ../core/src/components/MarketSection.tsx





var MarketSection = function(param) {
    var title = param.title, icon = param.icon, info = param.info, bulletPoints = param.bulletPoints;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col mb-9 md:mb-0 last:mb-0 max-w-md mx-0 md:mx-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mr-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage/* ResponsiveImage */.t, {
                            src: icon,
                            sizes: [
                                24,
                                28
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-black font-poppins text-xl md:text-2xl font-bold",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "hidden md:block text-gray-700 text-base leading-7 mb-5",
                children: info
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col",
                children: bulletPoints.map(function(bp, i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mr-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                    src: tick_green/* default */.Z,
                                    size: 15,
                                    className: "py-1"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-gray-700 text-sm md:text-base leading-6 flex-1 mb-2",
                                children: bp
                            })
                        ]
                    }, "bp-".concat(i));
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
// EXTERNAL MODULE: ../graphql/src/generated/index.ts + 11 modules
var generated = __webpack_require__(63575);
// EXTERNAL MODULE: ../core/src/utils/index.ts
var utils = __webpack_require__(75920);
// EXTERNAL MODULE: ../core/src/components/ActiveTag.tsx
var ActiveTag = __webpack_require__(77652);
// EXTERNAL MODULE: ../core/src/components/Countdown.tsx
var Countdown = __webpack_require__(699);
// EXTERNAL MODULE: ../assets/icons/pin.png
var pin = __webpack_require__(74939);
;// CONCATENATED MODULE: ../core/src/components/ForestCard.tsx












function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "bg-white overflow-hidden text-left flex flex-1 mx-4 md:max-w-sm flex-col rounded-lg mb-8 md:mb-0"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "flex flex-row"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "flex-1 flex flex-col"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "text-gray-700 text-xs uppercase mb-2 whitespace-nowrap"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "text-black font-poppins text-lg"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "absolute left-3 top-3"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
var AuctionCardMap = (0,utils/* clientOnlyModule */.EG)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3164), __webpack_require__.e(5016), __webpack_require__.e(499), __webpack_require__.e(5318), __webpack_require__.e(4836), __webpack_require__.e(461)]).then(__webpack_require__.bind(__webpack_require__, 87959));
});
var Container = dist_default().div(_templateObject());
var Line = dist_default().div(_templateObject1());
var PriceContainer = dist_default().div(_templateObject2());
var PriceTitle = dist_default().p(_templateObject3());
var Price = dist_default().p(_templateObject4());
var LiveTag = dist_default()(ActiveTag/* ActiveTag */.M)(_templateObject5());
var ForestCard = function(param) {
    var title = param.title, address = param.address, startingBid = param.startingBid, endTime = param.endTime, cadastralPlots = param.cadastralPlots, highestBidObject = param.highestBidObject, id = param.id;
    var t = (0,esm/* useTranslation */.$G)().t;
    (0,generated/* useBaseAuctionChangedSubscription */.oPU)({
        variables: {
            id: id
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full h-48 relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuctionCardMap, {
                        cadastralPlots: cadastralPlots
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveTag, {
                        active: true,
                        title: "LIVE"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-1 flex-col p-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-poppins font-bold text-lg mb-4",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                        className: "items-center mb-3 mt-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex mr-3 min-w-[24px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    src: pin/* default */.Z,
                                    width: 24,
                                    height: 24
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-gray-700 text-sm",
                                children: address
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown/* Countdown */.I, {
                            endTime: endTime,
                            showTimestamp: false
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Line, {
                        className: "pl-9 mb-5 text-gray-700 text-sm",
                        children: (0,utils/* endTimestamp */.mE)(endTime)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceTitle, {
                                        children: t('startingPrice')
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                        children: (0,utils/* formatMoney */.lb)(startingBid)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceTitle, {
                                        children: t('highestBid')
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                        className: "font-semibold",
                                        children: (0,utils/* formatMoney */.lb)(highestBidObject === null || highestBidObject === void 0 ? void 0 : highestBidObject.price)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/auctions/".concat(id),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            title: t('learnMore'),
                            value: "forest-card-nav-to-auction"
                        })
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63964);
// EXTERNAL MODULE: ../core/src/components/Navigation/NavBar.tsx + 7 modules
var NavBar = __webpack_require__(42234);
// EXTERNAL MODULE: ../core/src/components/BackgroundImage.tsx
var BackgroundImage = __webpack_require__(59645);
// EXTERNAL MODULE: ../core/src/components/Card.tsx
var Card = __webpack_require__(28658);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../core/src/components/Forms/Form.tsx
var Form = __webpack_require__(48375);
// EXTERNAL MODULE: ../core/src/components/Inputs/Select.tsx
var Select = __webpack_require__(41673);
// EXTERNAL MODULE: ../core/src/components/Inputs/TextInput.tsx
var TextInput = __webpack_require__(10809);
// EXTERNAL MODULE: ../core/src/components/Inputs/CheckBox.tsx
var CheckBox = __webpack_require__(76008);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../core/src/components/Modal.tsx
var Modal = __webpack_require__(27581);
// EXTERNAL MODULE: ../core/src/components/Inputs/PhoneInput.tsx + 1 modules
var PhoneInput = __webpack_require__(70331);
;// CONCATENATED MODULE: ../assets/images/calculator-modal.png
/* harmony default export */ var calculator_modal = ({"src":"/_next/static/media/calculator-modal.24c2bed7.png","height":959,"width":800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAM1BMVEVWTA+AfRUyLAl3cRUZGQBkXw5cWAk9OApFQAxmYgguQASEcR4vMwMjJgGHfz5wZhmXjStb/hQOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVQImQXBhwHAIAzAMIdsZv+/thI2MuNebJxsEWxsRBTLivaPU9Htj5ml6sHcOAW9FmT9LPMBZtAuoNoAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ../assets/icons/foros-logo-white.svg
var foros_logo_white = __webpack_require__(46127);
;// CONCATENATED MODULE: ../core/src/components/RoughPriceInquiryModal.tsx


















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function RoughPriceInquiryModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function RoughPriceInquiryModal_templateObject() {
    var data = RoughPriceInquiryModal_taggedTemplateLiteral([
        "font-bold mb-4 text-gray-800"
    ]);
    RoughPriceInquiryModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RoughPriceInquiryModal_templateObject1() {
    var data = RoughPriceInquiryModal_taggedTemplateLiteral([
        "flex flex-col space-y-6"
    ]);
    RoughPriceInquiryModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RoughPriceInquiryModal_templateObject2() {
    var data = RoughPriceInquiryModal_taggedTemplateLiteral([
        "\n  hidden\n  md:flex\n  absolute\n  left-[-300px]\n  bottom-[-1px]\n  top-[-1px]\n  w-[305px]\n  items-center\n  justify-center\n  rounded-l-lg\n  overflow-hidden\n"
    ]);
    RoughPriceInquiryModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var Text = dist_default().p(RoughPriceInquiryModal_templateObject());
var InputsContainer = dist_default().div(RoughPriceInquiryModal_templateObject1());
var BgImgContainer = dist_default().div(RoughPriceInquiryModal_templateObject2());
var RoughPriceInquiryModal = function(param1) {
    var open = param1.open, onClose = param1.onClose, id = param1.inquiryId;
    var t = (0,esm/* useTranslation */.$G)([
        'inquiries',
        'common'
    ]).t;
    var form = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            phoneNumber: ''
        }
    });
    var router = (0,next_router.useRouter)();
    var ref1 = _slicedToArray((0,generated/* useUpdateRoughPriceInquiryContactsMutation */.AEs)(), 1), updateRoughPriceInquiryContacts = ref1[0];
    var register = form.register, control = form.control, setError = form.setError;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(input) {
            var ref, data, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return updateRoughPriceInquiryContacts({
                            variables: {
                                input: _objectSpread({}, input, {
                                    id: id
                                })
                            }
                        });
                    case 3:
                        data = _ctx.sent.data;
                        error = data === null || data === void 0 ? void 0 : (ref = data.updateRoughPriceInquiryContacts) === null || ref === void 0 ? void 0 : ref.error;
                        if (error) {
                            if (error.email) {
                                setError('email', (0,utils/* getErrorTranslations */.Hm)('UpdateRoughPriceInquiryContactsEmailError', error.email));
                            }
                            if (error.phoneNumber) {
                                setError('phoneNumber', (0,utils/* getErrorTranslations */.Hm)('UpdateRoughPriceInquiryContactsPhoneNumberError', error.phoneNumber));
                            }
                        } else {
                            router.push("/price-inquiries/".concat(id));
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(input) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router,
        id,
        setError,
        updateRoughPriceInquiryContacts
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
        open: open,
        onClose: onClose,
        cardClassname: "md:ml-[300px] text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                className: "text-2xl",
                children: t('roughPrice.calculatedTitle')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                className: "text-lg",
                children: t('roughPrice.calculatedSubtitle')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                className: "font-medium",
                children: t('roughPrice.enterContacts')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, _objectSpread({}, form, {
                onSubmit: onSubmit,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputsContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, _objectSpread({
                            label: t('common:email')
                        }, register('email', {
                            required: true
                        }))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                            control: control,
                            name: "phoneNumber",
                            rules: {
                                required: true
                            },
                            render: function(param) {
                                var field = param.field;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(PhoneInput/* PhoneInput */.s, _objectSpread({
                                    label: t('common:phoneNumber')
                                }, field));
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            type: "submit",
                            value: "rough-price-inquiry",
                            title: t('roughPrice.getPriceNow')
                        })
                    ]
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BgImgContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* BackgroundImage */.X, {
                        src: calculator_modal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                        src: foros_logo_white/* default */.Z,
                        width: 164,
                        height: 40,
                        className: "relative"
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../core/src/components/Forms/PriceCalculator.tsx














function PriceCalculator_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function PriceCalculator_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function PriceCalculator_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function PriceCalculator_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                PriceCalculator_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                PriceCalculator_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function PriceCalculator_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PriceCalculator_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function PriceCalculator_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function PriceCalculator_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PriceCalculator_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function PriceCalculator_slicedToArray(arr, i) {
    return PriceCalculator_arrayWithHoles(arr) || PriceCalculator_iterableToArrayLimit(arr, i) || PriceCalculator_unsupportedIterableToArray(arr, i) || PriceCalculator_nonIterableRest();
}
function PriceCalculator_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PriceCalculator_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return PriceCalculator_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return PriceCalculator_arrayLikeToArray(o, minLen);
}
function PriceCalculator_templateObject() {
    var data = PriceCalculator_taggedTemplateLiteral([
        "text-xl font-semibold self-start"
    ]);
    PriceCalculator_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Title = dist_default().p(PriceCalculator_templateObject());
var PriceCalculator = function() {
    var ref4, ref1;
    var t = (0,esm/* useTranslation */.$G)([
        'inquiries',
        'auctions',
        'enum'
    ]).t;
    var ref2 = (0,react.useState)(false), modalOpen = ref2[0], setModalOpen = ref2[1];
    var ref3 = PriceCalculator_slicedToArray((0,generated/* useCreateRoughPriceInquiryMutation */.DWs)(), 2), createRoughPriceInquiryMutation = ref3[0], data1 = ref3[1].data;
    var form = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            intents: []
        }
    });
    var register = form.register, control = form.control, setError = form.setError;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = PriceCalculator_asyncToGenerator(runtime_default().mark(function _callee(_param) {
            var area, input, ref, data, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        area = _param.area, input = _objectWithoutProperties(_param, [
                            "area"
                        ]);
                        ;
                        _ctx.next = 4;
                        return createRoughPriceInquiryMutation({
                            variables: {
                                input: PriceCalculator_objectSpread({}, input, {
                                    area: parseFloat(area)
                                })
                            }
                        });
                    case 4:
                        data = _ctx.sent.data;
                        error = data === null || data === void 0 ? void 0 : (ref = data.createRoughPriceInquiry) === null || ref === void 0 ? void 0 : ref.error;
                        if (error) {
                            if (error.intents) {
                                setError('intents', (0,utils/* getErrorTranslations */.Hm)('CreateRoughPriceInquiryIntentsError', error.intents));
                            }
                        } else {
                            setModalOpen(true);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }(), [
        createRoughPriceInquiryMutation,
        setError
    ]);
    var forestTypeOptions = (0,react.useMemo)(function() {
        return (0,utils/* enumToOption */.$1)(generated/* ForestType */.dDq).map(function(param) {
            var label = param.label, value = param.value;
            return {
                label: t("enum:ForestType.".concat(label)),
                value: value
            };
        });
    }, [
        t
    ]);
    var maturityOptions = (0,react.useMemo)(function() {
        return (0,utils/* enumToOption */.$1)(generated/* TaxonomicPlotMaturityCondition */.CzM).map(function(param) {
            var label = param.label, value = param.value;
            return {
                label: t("enum:TaxonomicPlotMaturityCondition.".concat(label)),
                value: value
            };
        });
    }, [
        t
    ]);
    var inquiryId = data1 === null || data1 === void 0 ? void 0 : (ref4 = data1.createRoughPriceInquiry) === null || ref4 === void 0 ? void 0 : (ref1 = ref4.roughPriceInquiry) === null || ref1 === void 0 ? void 0 : ref1.id;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, PriceCalculator_objectSpread({}, form, {
                onSubmit: onSubmit,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col space-y-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: t('title')
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, PriceCalculator_objectSpread({
                            type: "number",
                            label: t('auctions:area'),
                            placeholder: t('common:hectare')
                        }, register('area', {
                            required: true
                        }))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                            control: control,
                            name: "leafType",
                            rules: {
                                required: true
                            },
                            render: function(param1) {
                                var field = param1.field;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Select/* Select */.P, PriceCalculator_objectSpread({
                                    label: t('auctions:forestType'),
                                    options: forestTypeOptions
                                }, field, {
                                    onChange: function(option) {
                                        return field.onChange(option === null || option === void 0 ? void 0 : option.value);
                                    },
                                    value: forestTypeOptions.find(function(param) {
                                        var value = param.value;
                                        return value === field.value;
                                    })
                                }));
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                            control: control,
                            name: "maturity",
                            rules: {
                                required: true
                            },
                            render: function(param2) {
                                var field = param2.field;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Select/* Select */.P, PriceCalculator_objectSpread({
                                    label: t('auctions:maturity'),
                                    options: maturityOptions
                                }, field, {
                                    onChange: function(option) {
                                        return field.onChange(option === null || option === void 0 ? void 0 : option.value);
                                    },
                                    value: maturityOptions.find(function(param) {
                                        var value = param.value;
                                        return value === field.value;
                                    })
                                }));
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col space-y-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* CheckBox */.J, PriceCalculator_objectSpread({
                                    label: t('roughPrice.sellIntent')
                                }, register('intents'), {
                                    value: "want_to_sell"
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* CheckBox */.J, PriceCalculator_objectSpread({
                                    label: t('roughPrice.investIntent')
                                }, register('intents'), {
                                    value: "income_without_selling"
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* CheckBox */.J, PriceCalculator_objectSpread({
                                    label: t('roughPrice.consultationIntent')
                                }, register('intents'), {
                                    value: "want_consultation"
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            type: "submit",
                            value: "price-calculator",
                            title: t('roughPrice.calculatePrice')
                        })
                    ]
                })
            })),
            inquiryId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RoughPriceInquiryModal, {
                open: modalOpen,
                inquiryId: inquiryId,
                onClose: function() {
                    return setModalOpen(false);
                }
            }) : null
        ]
    }));
};


// EXTERNAL MODULE: ../core/src/hooks/index.ts
var hooks = __webpack_require__(32345);
// EXTERNAL MODULE: ../core/src/config/theme.js
var theme = __webpack_require__(46487);
var theme_default = /*#__PURE__*/__webpack_require__.n(theme);
// EXTERNAL MODULE: ../core/src/config/domains.js
var domains = __webpack_require__(2811);
var domains_default = /*#__PURE__*/__webpack_require__.n(domains);
;// CONCATENATED MODULE: ../assets/images/hero.png
/* harmony default export */ var hero = ({"src":"/_next/static/media/hero.01c63a05.png","height":1994,"width":3840,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAALVBMVEUZMjeRp6ESIiqbr6k8X14pSk8FChFOaGkhPkRbfnpkg4MNFx18m5Vvios5XVzx4wYrAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKElEQVQImRXBhw0AMAgDsIQNHf+fW9VGN5U6G3apc9zglVkQwScr4gENKgCnEy3y7gAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ../assets/images/hero-mobile.png
/* harmony default export */ var hero_mobile = ({"src":"/_next/static/media/hero-mobile.fc168667.png","height":1302,"width":1125,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAPFBMVEUfLTFoj4lJa2uEnpmor6u4wr0nOz03T1EvRUZ4lpEUHiOdpqE9W1xYgHtxmZJufHpRcHKDh4NeaGgJDxZRLd9cAAAACXBIWXMAACE4AAAhOAFFljFgAAAAOklEQVQImRXGxRHAMBAEsD3ykSHQf6+Z6CWoquQmqJmkbLRZUhLubr7WwnOOT2aE+wifKAAjHG/Vnw8zhQGhwei5EAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ../assets/images/ma-logo-white.png
/* harmony default export */ var ma_logo_white = ({"src":"/_next/static/media/ma-logo-white.25d33309.png","height":570,"width":811,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAGFBMVEX///////////////9MaXH////////////jNUl5AAAACHRSTlMyPGByAEsqhoNV/W4AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAoSURBVAiZHcbJDQAwCASx2QPov+NI8cu0XbflMrYTRiuQ0PJLmDj2AwtCAG6burnIAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ../core/src/components/ForosLVHero.tsx



















function ForosLVHero_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ForosLVHero_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ForosLVHero_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ForosLVHero_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ForosLVHero_templateObject() {
    var data = ForosLVHero_taggedTemplateLiteral([
        "md:min-h-[796px] min-h-screen flex flex-col relative bg-green-700"
    ]);
    ForosLVHero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ForosLVHero_templateObject1() {
    var data = ForosLVHero_taggedTemplateLiteral([
        "text-lg md:leading-normal font-poppins md:text-4xl font-bold"
    ]);
    ForosLVHero_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ForosLVHero_templateObject2() {
    var data = ForosLVHero_taggedTemplateLiteral([
        "\n  container\n  z-30\n  flex-1\n  flex\n  flex-col\n  justify-start\n  md:justify-around\n  text-white\n  text-center\n  pt-24\n  pb-12\n  space-y-8\n"
    ]);
    ForosLVHero_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ForosLVHero_templateObject3() {
    var data = ForosLVHero_taggedTemplateLiteral([
        "\n  hidden\n  md:block\n  z-20\n  absolute\n  bg-gradient-to-r\n  left-0\n  right-0\n  bottom-0\n  top-[68px]\n  from-green-700\n  via-transparent\n  to-green-700\n"
    ]);
    ForosLVHero_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ForosLVHero_templateObject4() {
    var data = ForosLVHero_taggedTemplateLiteral([
        "z-10 absolute left-0 right-0 bottom-0 top-[68px]"
    ]);
    ForosLVHero_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ForosLVHero_templateObject5() {
    var data = ForosLVHero_taggedTemplateLiteral([
        "\n  border-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    ForosLVHero_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
var ForosLVHero_Container = dist_default().div(ForosLVHero_templateObject());
var Heading = dist_default().h1(ForosLVHero_templateObject1());
var MainContainer = dist_default().div(ForosLVHero_templateObject2());
var GradientContainer = dist_default().div(ForosLVHero_templateObject3());
var HeroContainer = dist_default().div(ForosLVHero_templateObject4());
var InvertedButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
    componentId: "sc-b98c1796-0"
})(ForosLVHero_templateObject5(), (theme_default()).colors.white, (theme_default()).colors.white);
var HeroStatistic = function(param) {
    var value = param.value, text = param.text;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center mx-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "font-bold text-4xl mb-4",
                children: value
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: text
            })
        ]
    });
};
var HeroBackground = (0,utils/* clientOnlyComponent */.V4)(function() {
    var mobile = (0,hooks/* useDeviceMediaQuery */.mL)().mobile;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(HeroContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* BackgroundImage */.X, {
            src: mobile ? hero_mobile : hero,
            priority: true
        })
    }));
});
var ForosLVHero = function() {
    var t = (0,esm/* useTranslation */.$G)('landing').t;
    var statistics = (0,react.useMemo)(function() {
        return [
            {
                value: '1,147+',
                text: t('totalDeals')
            },
            {
                value: '11 319 ha',
                text: t('totalArea', {
                    totalSumOfAllEndedAuctions: (0,utils/* formatMoney */.lb)({
                        amount: '26547748',
                        __typename: 'MoneyObject',
                        currency: {
                            __typename: 'Currency',
                            isoCode: generated/* CurrencyCode.Eur */.NEm.Eur
                        }
                    }, {
                        minimumFractionDigits: 0
                    })
                })
            },
            {
                value: '12 648',
                text: t('totalBids')
            },
            {
                value: '€17,599/ha',
                text: t('highestBid')
            }, 
        ];
    }, [
        t
    ]);
    var isMA = (domains_default()).current.name === 'miskoaukcionas.lt';
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ForosLVHero_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBar/* NavBar */.l, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientContainer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBackground, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-1 flex-col md:flex-row space-x-0 md:space-x-8 space-y-8 md:space-y-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-center md:items-start flex-1 space-y-8 md:text-left",
                                children: [
                                    isMA ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: ma_logo_white,
                                        width: 320,
                                        height: 224.906
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                        children: isMA ? t('topHeadingMA') : t('topHeading')
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t('subheading')
                                    }),
                                    isMA ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t('partOfForos')
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "/auctions",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InvertedButton, {
                                            title: t('secondaryCTA'),
                                            value: "hero-secondary",
                                            outline: true
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                className: "md:flex-1 text-black md:self-start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceCalculator, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-between flex-col md:flex-row space-y-4 md:space-y-0",
                        children: statistics.map(function(stat) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(HeroStatistic, ForosLVHero_objectSpread({}, stat), stat.value);
                        })
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ../core/src/hooks/authentication.ts
var authentication = __webpack_require__(96172);
;// CONCATENATED MODULE: ../core/src/components/ForestValueInquiryModal.tsx
















function ForestValueInquiryModal_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ForestValueInquiryModal_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ForestValueInquiryModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ForestValueInquiryModal_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ForestValueInquiryModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ForestValueInquiryModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ForestValueInquiryModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ForestValueInquiryModal_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ForestValueInquiryModal_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ForestValueInquiryModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ForestValueInquiryModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ForestValueInquiryModal_slicedToArray(arr, i) {
    return ForestValueInquiryModal_arrayWithHoles(arr) || ForestValueInquiryModal_iterableToArrayLimit(arr, i) || ForestValueInquiryModal_unsupportedIterableToArray(arr, i) || ForestValueInquiryModal_nonIterableRest();
}
function ForestValueInquiryModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ForestValueInquiryModal_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ForestValueInquiryModal_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ForestValueInquiryModal_arrayLikeToArray(o, minLen);
}
function ForestValueInquiryModal_templateObject() {
    var data = ForestValueInquiryModal_taggedTemplateLiteral([
        "font-medium text-2xl mb-6 text-gray-800"
    ]);
    ForestValueInquiryModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ForestValueInquiryModal_templateObject1() {
    var data = ForestValueInquiryModal_taggedTemplateLiteral([
        "flex flex-col space-y-6"
    ]);
    ForestValueInquiryModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ForestValueInquiryModal_templateObject2() {
    var data = ForestValueInquiryModal_taggedTemplateLiteral([
        "text-primary-500 hover:underline cursor-pointer"
    ]);
    ForestValueInquiryModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var ForestValueInquiryModal_Title = dist_default().p(ForestValueInquiryModal_templateObject());
var ForestValueInquiryModal_InputsContainer = dist_default().div(ForestValueInquiryModal_templateObject1());
var NavLink = dist_default().span(ForestValueInquiryModal_templateObject2());
var ForestValueInquiryModal = function(param1) {
    var open = param1.open, onClose = param1.onClose;
    var t = (0,esm/* useTranslation */.$G)([
        'inquiries',
        'common',
        'authentication'
    ]).t;
    var form = (0,index_esm/* useForm */.cI)();
    var ref2 = ForestValueInquiryModal_slicedToArray((0,generated/* useCreateForestValueInquiryMutation */.zAW)(), 1), createForestValueInquiryMutation = ref2[0];
    var login = (0,authentication/* useLogin */.f0)();
    var register = form.register, control = form.control, setError = form.setError;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = ForestValueInquiryModal_asyncToGenerator(runtime_default().mark(function _callee(input) {
            var ref, ref1, data, error, token;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return createForestValueInquiryMutation({
                            variables: {
                                input: input
                            }
                        });
                    case 3:
                        data = _ctx.sent.data;
                        error = data === null || data === void 0 ? void 0 : (ref = data.signUpWithEmail) === null || ref === void 0 ? void 0 : ref.error;
                        token = data === null || data === void 0 ? void 0 : (ref1 = data.signUpWithEmail) === null || ref1 === void 0 ? void 0 : ref1.token;
                        if (!error) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", (0,utils/* setFormFieldsErrorTranslations */.U5)(setError, error, {
                            email: 'SignUpWithEmailEmailError',
                            password: 'SignUpWithEmailPasswordError',
                            phoneNumber: 'SignUpWithEmailPhoneNumberError',
                            termsAndConditionsAccepted: 'SignUpWithEmailTermsAndConditionsAcceptedError'
                        }));
                    case 8:
                        login(token);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(input) {
            return _ref.apply(this, arguments);
        };
    }(), [
        login,
        createForestValueInquiryMutation,
        setError
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
        open: open,
        onClose: onClose,
        cardClassname: "text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ForestValueInquiryModal_Title, {
                children: t('forestValue.title')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, ForestValueInquiryModal_objectSpread({}, form, {
                onSubmit: onSubmit,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ForestValueInquiryModal_InputsContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, ForestValueInquiryModal_objectSpread({
                            label: t('common:email')
                        }, register('email', {
                            required: true
                        }))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, ForestValueInquiryModal_objectSpread({
                            label: t('authentication:password'),
                            type: "password"
                        }, register('password', {
                            required: true
                        }))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                            control: control,
                            name: "phoneNumber",
                            render: function(param) {
                                var field = param.field;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(PhoneInput/* PhoneInput */.s, ForestValueInquiryModal_objectSpread({
                                    label: t('common:phoneNumber')
                                }, field));
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, ForestValueInquiryModal_objectSpread({
                            label: t('common:enterCadastralNumber')
                        }, register('cadastralNumber'))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* CheckBox */.J, ForestValueInquiryModal_objectSpread({
                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    t('common:iAgreeWith'),
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "/rules",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                                            children: t('common:nav.rules')
                                        })
                                    }),
                                    ' ',
                                    t('common:connectors.and'),
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "/privacy-policy",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                                            children: t('common:nav.privacyPolicy')
                                        })
                                    })
                                ]
                            })
                        }, register('termsAndConditionsAccepted'))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* CheckBox */.J, ForestValueInquiryModal_objectSpread({
                            label: t('common:marketingAgreement')
                        }, register('marketingConditionsAccepted'))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            type: "submit",
                            value: "forest-value-inquiry",
                            title: t('forestValue.register')
                        })
                    ]
                })
            }))
        ]
    }));
};

;// CONCATENATED MODULE: ../core/src/components/IconLabel.tsx


var IconLabel = function(param) {
    var icon = param.icon, text = param.text;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center ml-3 mr-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex mr-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    src: icon,
                    width: 20,
                    height: 20
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-white font-bold",
                children: text
            })
        ]
    });
};

;// CONCATENATED MODULE: ../assets/icons/auction.png
/* harmony default export */ var auction = ({"src":"/_next/static/media/auction.5e9cf786.png","height":60,"width":60,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEX///////////////////////////////////////////9/gMdvAAAAC3RSTlMBlBRriLdNNatJ2q1LkAgAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAzSURBVAiZJYtbDgAgDMLKHk69/4HNJh+kCQWAsG7w1JCL2MC5eM6yUrEAw631kqL+6ecBEKYAdJxTXVkAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ../assets/icons/grow.png
/* harmony default export */ var grow = ({"src":"/_next/static/media/grow.652169f5.png","height":60,"width":60,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEX///9MaXH////////////////////////////////////+/v7Z/SAIAAAADHRSTlO8AJPiyKwhNRSeBGejHPZ0AAAACXBIWXMAACE4AAAhOAFFljFgAAAANElEQVQImRXKtxHAMBDAMPKTgvff16caQL2diNEQR6wgY4ur81NxD2fmnWwyHqEs0aoq/QEazAC64fqWWQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ../assets/icons/sell.png
/* harmony default export */ var sell = ({"src":"/_next/static/media/sell.f974a38a.png","height":60,"width":60,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEVMaXH////////////////////////////////////////////////////m1kuZAAAADnRSTlMAkRm+fGKGVAktc9k4oum6/rUAAAAJcEhZcwAAITgAACE4AUWWMWAAAAA3SURBVAiZJcvJEcAgDACx9Q026b/dDIn+AtDFZ0+rAmtl2AM1ctQLwkJMehOTLmLF9s7087/rBSS9AQIM4DnAAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ../core/src/components/Hero.tsx


















function Hero_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Hero_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Hero_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Hero_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Hero_templateObject() {
    var data = Hero_taggedTemplateLiteral([
        "min-h-screen md:min-h-[796px] flex flex-col relative bg-green-700"
    ]);
    Hero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Hero_templateObject1() {
    var data = Hero_taggedTemplateLiteral([
        "text-lg md:text-3xl lg:text-4xl font-bold"
    ]);
    Hero_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Hero_templateObject2() {
    var data = Hero_taggedTemplateLiteral([
        "text-5xl md:text-8xl xl:text-9xl font-bold"
    ]);
    Hero_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Hero_templateObject3() {
    var data = Hero_taggedTemplateLiteral([
        "\n  container\n  z-30\n  flex\n  flex-col\n  items-center\n  justify-start\n  md:justify-around\n  text-white\n  text-center\n  px-4\n  xl:px-0\n"
    ]);
    Hero_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Hero_templateObject4() {
    var data = Hero_taggedTemplateLiteral([
        "\n  hidden\n  md:block\n  z-20\n  absolute\n  bg-gradient-to-r\n  left-0\n  right-0\n  bottom-0\n  top-[68px]\n  from-green-700\n  via-transparent\n  to-green-700\n"
    ]);
    Hero_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Hero_templateObject5() {
    var data = Hero_taggedTemplateLiteral([
        "z-10 absolute left-0 right-0 bottom-0 top-[68px]"
    ]);
    Hero_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = Hero_taggedTemplateLiteral([
        "\n  border-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
var Hero_Container = dist_default().div(Hero_templateObject());
var Hero_Heading = dist_default().p(Hero_templateObject1());
var MiddleHeading = dist_default().p(Hero_templateObject2());
var Hero_MainContainer = dist_default().div(Hero_templateObject3());
var Hero_GradientContainer = dist_default().div(Hero_templateObject4());
var Hero_HeroContainer = dist_default().div(Hero_templateObject5());
var Hero_InvertedButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
    componentId: "sc-e7182a03-0"
})(_templateObject6(), (theme_default()).colors.white, (theme_default()).colors.white);
var Hero_HeroStatistic = function(param) {
    var value = param.value, text = param.text;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center mx-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "font-bold text-4xl mb-4",
                children: value
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: text
            })
        ]
    });
};
var Hero_HeroBackground = (0,utils/* clientOnlyComponent */.V4)(function() {
    var mobile = (0,hooks/* useDeviceMediaQuery */.mL)().mobile;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_HeroContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* BackgroundImage */.X, {
            src: mobile ? hero_mobile : hero,
            priority: true
        })
    }));
});
var Hero = function(param) {
    var onPrimaryClick = param.onPrimaryClick;
    var t = (0,esm/* useTranslation */.$G)('landing').t;
    var marketFeatures = (0,react.useMemo)(function() {
        return [
            {
                icon: auction,
                text: t('buy')
            },
            {
                icon: grow,
                text: t('grow')
            },
            {
                icon: sell,
                text: t('sell')
            }, 
        ];
    }, [
        t
    ]);
    var statistics = (0,react.useMemo)(function() {
        return [
            {
                value: '€24M+',
                text: t('totalDealAmount')
            },
            {
                value: '€17,599/ha',
                text: t('highestBid')
            }, 
        ];
    }, [
        t
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBar/* NavBar */.l, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_GradientContainer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_HeroBackground, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero_MainContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center my-10",
                        children: marketFeatures.map(function(feature) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(IconLabel, Hero_objectSpread({}, feature), feature.text);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Heading, {
                        className: "mb-4",
                        children: t('topHeading')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleHeading, {
                        className: "mb-4",
                        children: t('middleHeading')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Heading, {
                        className: "mb-6",
                        children: t('bottomHeading')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-center md:mx-[24%] mb-8",
                        children: t('subheading')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-10 flex flex-col md:flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                value: "hero-primary",
                                onClick: onPrimaryClick,
                                title: t('primaryCTA'),
                                className: "mr-0 md:mr-8 mb-4 md:mb-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/auctions",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_InvertedButton, {
                                    title: t('secondaryCTA'),
                                    value: "hero-secondary",
                                    outline: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col md:flex-row space-y-4 md:space-y-0 mb-10 justify-center",
                        children: statistics.map(function(stat) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Hero_HeroStatistic, Hero_objectSpread({}, stat), stat.value);
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../core/src/components/SellingSection.tsx



var SellingSection = function(param) {
    var title = param.title, icon = param.icon, info = param.info, _className = param.className, className = _className === void 0 ? '' : _className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col md:flex-row items-center md:items-start z-30 mb-10 md:mb-14 last:mb-0 ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mr-0 md:mr-9 mb-2 md:mb-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage/* ResponsiveImage */.t, {
                    src: icon,
                    sizes: [
                        30,
                        60
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col flex-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-white font-poppins text-xl md:text-2xl mb-2 md:mb-4 break-all",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-white text-sm md:text-base md:leading-7",
                        children: info
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../assets/icons/sell-green.png
/* harmony default export */ var sell_green = ({"src":"/_next/static/media/sell-green.4a472d4d.png","height":84,"width":84,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJ1BMVEVMaXEgm4Qgm4Qgm4QgnIQgm4Qgm4Qgm4Qgm4Qgm4Qgm4Qgm4Qgm4Qv6qkLAAAADXRSTlMAiSh8FUBuXt23ypqbY0BLUAAAAAlwSFlzAAAhOAAAITgBRZYxYAAAADZJREFUCJk1y8kNgDAQBMGevW2Tf7wgWdS/AIwrpyKACO/9QI/SPKFXn33cqJFLK7Eqyf/45RcfRADYVgsSDgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ../assets/images/selling-cover.png
/* harmony default export */ var selling_cover = ({"src":"/_next/static/media/selling-cover.39dcfd6d.png","height":806,"width":1027,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAElBMVEUINkIpWGAZSE8eT1oRQUo3YGIbMFJVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJElEQVQImWXBAQEAMAzCMFqYf8sX8CQtUEhnKRe1cJdtOs3nAQsdAFK/a9gDAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ../assets/icons/track-golden.png
/* harmony default export */ var track_golden = ({"src":"/_next/static/media/track-golden.86bb4b04.png","height":180,"width":180,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEXZsw/Zsg/Zsw/Zsg/Zsw/Zsw/Zsg/ZshDZsg/Ysw+BzmyPAAAACnRSTlMBaHVYDDyJGi3EoYN+YwAAAAlwSFlzAAAhOAAAITgBRZYxYAAAADRJREFUCJkdyckNwEAMA7GR5Wv7bzhwfgRITuIuaFWZGAJW03lgLf84E9gvfVVbaOiQpM4PG+YAwE3KcsIAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ../assets/icons/buy-golden.png
/* harmony default export */ var buy_golden = ({"src":"/_next/static/media/buy-golden.fe8aa17a.png","height":180,"width":180,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEVMaXHZsw/Ysg/Zsw/ZshDZsw/YsxDYsw/Zsw/ZshDYsg+KaYqNAAAAC3RSTlMAeisTPiBZjg5uq/VyP9AAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAzSURBVAiZJYtBDgAgCMO6AaL+/8GGeFmTNgMgcxZC8mfQCamNj8HCtyZVa4+BKGKx9D8PEX4AjEhoGN8AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ../assets/icons/deal-golden.png
/* harmony default export */ var deal_golden = ({"src":"/_next/static/media/deal-golden.f4438a70.png","height":180,"width":180,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEVMaXHYsg/Ysg/Ysg/Zsg/Ysg/Ysg/Ysg/9J9dtAAAACHRSTlMAZ1QrfkURG/z1BkYAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAvSURBVAiZLcVBDsAwDMMwyU7a//94GFBeyN2oW2wtd5CJF8lyMELKTgHinH94PR8VOAB1WtloKwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ../core/src/components/SellingSections.tsx














function SellingSections_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SellingSections_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SellingSections_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SellingSections_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SellingSections_templateObject() {
    var data = SellingSections_taggedTemplateLiteral([
        "\n  container\n  relative\n  flex\n  ",
        "\n  px-6\n  md:px-0\n"
    ]);
    SellingSections_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var ContentContainer = dist_default().div(SellingSections_templateObject(), function(p) {
    return p.row ? 'flex-row' : 'flex-col';
});
var SellingSections = (0,utils/* clientOnlyComponent */.V4)(function(param) {
    var onClick = param.onClick;
    var mobile = (0,hooks/* useDeviceMediaQuery */.mL)().mobile;
    var t = (0,esm/* useTranslation */.$G)('landing').t;
    var sellingSections = (0,react.useMemo)(function() {
        return [
            {
                title: t('sellingSection.tracking.heading'),
                icon: track_golden,
                info: t('sellingSection.tracking.content')
            },
            {
                title: t('sellingSection.auction.heading'),
                icon: buy_golden,
                info: t('sellingSection.auction.content')
            },
            {
                title: t('sellingSection.deal.heading'),
                icon: deal_golden,
                info: t('sellingSection.deal.content')
            }, 
        ];
    }, [
        t
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative box-border border-gray-300",
        children: mobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
                    className: "py-14",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionDesc, {
                        className: "items-center text-center max-w-xl",
                        icon: sell_green,
                        sectionTitle: t('sellingSection.title'),
                        title: t('sellingSection.heading'),
                        info: t('sellingSection.content'),
                        onClick: onClick
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-screen relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* BackgroundImage */.X, {
                            src: selling_cover
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
                            className: "py-14 text-center",
                            children: sellingSections.map(function(s, i) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(SellingSection, SellingSections_objectSpread({}, s), "ss-".concat(i));
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute z-10 top-0 bottom-0 left-0 right-2/4 bg-cover bg-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* BackgroundImage */.X, {
                        src: selling_cover
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container flex py-48",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-1 flex-col mr-28",
                            children: sellingSections.map(function(s, i) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(SellingSection, SellingSections_objectSpread({}, s), "ss-".concat(i));
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex-1 ml-28",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionDesc, {
                                className: "items-start max-w-xl",
                                icon: sell_green,
                                sectionTitle: t('sellingSection.title'),
                                title: t('sellingSection.heading'),
                                info: t('sellingSection.content'),
                                onClick: onClick
                            })
                        })
                    ]
                })
            ]
        })
    }));
});

// EXTERNAL MODULE: ../core/src/components/Navigation/FooterLanding.tsx + 5 modules
var FooterLanding = __webpack_require__(56993);
// EXTERNAL MODULE: ../core/src/components/AuthModal.tsx
var AuthModal = __webpack_require__(14264);
// EXTERNAL MODULE: ../graphql/src/queries/Auctions.ts
var Auctions = __webpack_require__(77990);
;// CONCATENATED MODULE: ../assets/icons/buy-green.png
/* harmony default export */ var buy_green = ({"src":"/_next/static/media/buy-green.7c1eb044.png","height":84,"width":84,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEUaoYYaooYaoYYaoYYaoYYaoYcaoYYaoYYaoYYuLYEoAAAACXRSTlMBEnyVUIqnyikphfHCAAAACXBIWXMAACE4AAAhOAFFljFgAAAAMUlEQVQImSWLQQ4AIAzCOmDq/19sphyaJg0AuIag1WMlYQPZaL2S3Z1JpFARu88//V0OvwBqFsrw/gAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ../assets/icons/grow-green.png
/* harmony default export */ var grow_green = ({"src":"/_next/static/media/grow-green.02e87a3a.png","height":84,"width":84,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEVMaXEgm4Qgm4Qgm4Qgm4Qgm4Qgm4Qgm4Qgm4Qgm4Qgm4QXHZg0AAAAC3RSTlMAh59prR54FbtaOrHfIoMAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAzSURBVAiZFYvJDcBAEMLM3Jv+C454IdkGAJWAUSgTiIx65j33edmN6XZz0rlpgdYuyu8fFU0AnOdsvpwAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ../assets/images/background-forest.png
/* harmony default export */ var background_forest = ({"src":"/_next/static/media/background-forest.1562793f.png","height":2697,"width":5175,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAALVBMVEX/+/n99/O9w7D48uuXo5Lx7eIjNz4sQ0Y9Tk/W18tlenCGl4NDXFjP0rtne27h7fJfAAAACXBIWXMAACE4AAAhOAFFljFgAAAAKElEQVQImWNgZGRgYGAAk4yMrKzMzAycTCws3Ey8TAwc7Gxs7Dx8XAAFrQCMK0CjyQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ../assets/images/portfolio.png
/* harmony default export */ var portfolio = ({"src":"/_next/static/media/portfolio.a9c0cc9c.png","height":1131,"width":1680,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAP1BMVEXx8vLz8vKyrLOJi4na29pMTEva2tpkY2SsrKyYmJh3fXitsa3g4ODv7+/j5OPd3t2np6fw9/T7/Pze396Ml40uDdShAAAAEnRSTlP9vAur/QNzI9Ez2MpM8eC3zKYj9gBhAAAACXBIWXMAACE4AAAhOAFFljFgAAAAMElEQVQImQXBiQGAIAwEwY0QEvBBT/qvlRna/Kz17hgSfw2up4LuwM8lRHCUkZlvbB5eAVkupRVyAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ../assets/images/partners/1.png
/* harmony default export */ var _1 = ({"src":"/_next/static/media/1.7238eb9d.png","height":52,"width":182,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEVcXFxcXFxcXFxbW1tcXFykOMH/AAAABXRSTlMXTC8DPhg05RMAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAZSURBVAiZBcEBAQAAAIIgy/5vDjChRVw69AERACE0r5TgAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ../assets/images/partners/2.png
/* harmony default export */ var _2 = ({"src":"/_next/static/media/2.a20bb10a.png","height":50,"width":105,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAFVBMVEVcXFxcXFxMaXFcXFxcXFxcXFxcXFxcphWRAAAAB3RSTlNgNQBNcR6TC29PBQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAB5JREFUCJljYGRkAgMGVjYGEGBkYGJmZmFgATGgAAAEOwA8QFWnxQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ../assets/images/partners/3.png
/* harmony default export */ var _3 = ({"src":"/_next/static/media/3.bf42945c.png","height":28,"width":144,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEVcXFxdXV1dXV1cXFxcXFxcXFxNxypNAAAABnRSTlN+UolBmm7d8McCAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVQImWNgYGZkYGVkZWBgYmZkYWJiYAEAASYAIrc9h/wAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ../assets/images/partners/4.png
/* harmony default export */ var _4 = ({"src":"/_next/static/media/4.e84c1713.png","height":40,"width":150,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEVcXFxcXFxcXFxcXFxcXFyWyhXuAAAABXRSTlNMBi4VJq1o5CYAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAXSURBVAiZY2BmZGRiYGZkZAABJgYGFgAAxQATobatyQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ../assets/images/partners/5.png
/* harmony default export */ var _5 = ({"src":"/_next/static/media/5.5afaaf58.png","height":20,"width":150,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAADFBMVEVcXFxcXFxcXFxdXV3WUTf5AAAABHRSTlMiKU0Q1lRdbAAAAAlwSFlzAAALEwAACxMBAJqcGAAAABFJREFUCJljYGJkZmBgZGQEAAA4AAol4dQQAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ../assets/images/partners/6.png
/* harmony default export */ var _6 = ({"src":"/_next/static/media/6.f640c714.png","height":38,"width":148,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEVeXl5bW1tbW1tcXFxaWlpbW1vD3PeXAAAABnRSTlMDK1NxPDHwhbDEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGUlEQVQImQXBAQEAAAgCINT+bw5gg8u1TR4AvQAYOGZPPwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ../assets/images/partners/7.png
/* harmony default export */ var _7 = ({"src":"/_next/static/media/7.3418c429.png","height":50,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAG1BMVEVcXFxcXFxcXFxcXFxcXFxcXFxcXFxcXFxcXFxfpLBDAAAACXRSTlMEdYmYZRS9UFsjru7IAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKklEQVQImRXBiQ3AIADEsNwH7D9xVRt+NbBKJwV0dFP0rmSPJHZkOraNDwunAIDLDJ94AAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ../assets/images/forest-book.png
var forest_book = __webpack_require__(68358);
;// CONCATENATED MODULE: ./src/pages/index.tsx





















function pages_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function pages_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            pages_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function pages_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function pages_templateObject() {
    var data = pages_taggedTemplateLiteral([
        "\n  container\n  relative\n  flex\n  ",
        "\n"
    ]);
    pages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function pages_templateObject1() {
    var data = pages_taggedTemplateLiteral([
        "flex m-4"
    ]);
    pages_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var pages_ContentContainer = dist_default().div(pages_templateObject(), function(p) {
    return p.$row ? 'flex-row' : 'flex-col';
});
var Partner = dist_default().div(pages_templateObject1());
var queryVariables = {
    first: 3
};
function MarketingSection(param) {
    var onClick = param.onClick;
    var t = (0,esm/* useTranslation */.$G)('landing').t;
    var marketSections = (0,react.useMemo)(function() {
        return [
            {
                title: t('buy'),
                icon: buy_green,
                info: t('buyMarket.content'),
                bulletPoints: [
                    t('buyMarket.bulletPoint1'),
                    t('buyMarket.bulletPoint2'),
                    t('buyMarket.bulletPoint3'), 
                ]
            },
            {
                title: t('grow'),
                icon: grow_green,
                info: t('growMarket.content'),
                bulletPoints: [
                    t('growMarket.bulletPoint1'),
                    t('growMarket.bulletPoint2'),
                    t('growMarket.bulletPoint3'), 
                ]
            },
            {
                title: t('sell'),
                icon: sell_green,
                info: t('sellMarket.content'),
                bulletPoints: [
                    t('sellMarket.bulletPoint1'),
                    t('sellMarket.bulletPoint2'),
                    t('sellMarket.bulletPoint3'), 
                ]
            }, 
        ];
    }, [
        t
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(pages_ContentContainer, {
        className: "pt-16 md:py-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionDesc, {
                className: "mb-16 md:mb-20 flex-1 items-center text-center",
                title: t('gainKnowledgeTitle'),
                info: t('gainKnowledgeContent'),
                onClick: onClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col md:flex-row justify-between text-left ",
                children: marketSections.map(function(s, i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(MarketSection, pages_objectSpread({}, s), "mc-".concat(i));
                })
            })
        ]
    }));
}
function FIMarketingSection(param) {
    var onClick = param.onClick;
    var t = (0,esm/* useTranslation */.$G)('landing').t;
    var marketSections = (0,react.useMemo)(function() {
        return [
            {
                title: t('buy'),
                icon: buy_green,
                info: t('buyMarket.content'),
                bulletPoints: [
                    t('buyMarket.bulletPoint1'),
                    t('buyMarket.bulletPoint2'),
                    t('buyMarket.bulletPoint3'), 
                ]
            },
            {
                title: t('sell'),
                icon: sell_green,
                info: t('sellMarket.content'),
                bulletPoints: [
                    t('sellMarket.bulletPoint1'),
                    t('sellMarket.bulletPoint2'),
                    t('sellMarket.bulletPoint3'), 
                ]
            }, 
        ];
    }, [
        t
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(pages_ContentContainer, {
        className: "pt-16 md:py-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionDesc, {
                className: "mb-16 md:mb-20 flex-1 items-center text-center",
                title: t('gainKnowledgeTitle'),
                info: t('gainKnowledgeContent'),
                onClick: onClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col md:flex-row justify-around text-left ",
                children: marketSections.map(function(s, i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(MarketSection, pages_objectSpread({}, s), "mc-".concat(i));
                })
            })
        ]
    }));
}
function AuctionsSection(param) {
    var onClick = param.onClick;
    var t = (0,esm/* useTranslation */.$G)('landing').t;
    var data = (0,Auctions/* usePaginatedBaseMarketAuctionQuery */.D)(queryVariables).data;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* BackgroundImage */.X, {
                src: background_forest
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute z-1 w-full h-full bg-gradient-to-b from-white via-transparent to-transparent"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(pages_ContentContainer, {
                className: "z-2 text-center pt-14 md:py-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionDesc, {
                        className: "items-center mb-20",
                        icon: buy_green,
                        sectionTitle: t('buyingSection.title'),
                        title: t('buyingSection.heading'),
                        info: t('buyingSection.content'),
                        onClick: onClick
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-1 flex-col md:flex-row justify-between -mx-4",
                        children: data === null || data === void 0 ? void 0 : data.marketAuctions.nodes.map(function(auction) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ForestCard, pages_objectSpread({}, auction), auction === null || auction === void 0 ? void 0 : auction.id);
                        })
                    })
                ]
            })
        ]
    }));
}
var ForestBookSection = function(param) {
    var onClick = param.onClick;
    var t = (0,esm/* useTranslation */.$G)('landing').t;
    return (domains_default()).current.forestBookEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container mt-8 flex flex-col-reverse md:flex-row space-x-0 md:space-x-8 space-y-4 space-y-reverse md:space-y-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                src: forest_book/* default */.Z,
                width: 160,
                height: 213.33,
                objectFit: "contain"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col flex-1 space-y-4 md:items-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-3xl font-bold",
                        children: t('forestBook.title')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-lg",
                        children: t('forestBook.description')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: onClick,
                        value: "open-inquiry-modal-landing",
                        title: t('forestBook.CTA')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t('forestBook.actionDescription')
                    })
                ]
            })
        ]
    }) : null;
};
function ForosLVLanding() {
    var t = (0,esm/* useTranslation */.$G)('landing').t;
    var ref = (0,react.useState)(false), authOpen = ref[0], setAuthOpen = ref[1];
    var ref1 = (0,react.useState)(false), inquiryModalOpen = ref1[0], setInquiryModalOpen = ref1[1];
    var openAuthModal = (0,react.useCallback)(function() {
        return setAuthOpen(true);
    }, [
        setAuthOpen
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ForosLVHero, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ForestBookSection, {
                    onClick: function() {
                        return setInquiryModalOpen(true);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuctionsSection, {
                    onClick: openAuthModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingSection, {
                    onClick: openAuthModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col border-t-2 py-8 space-y-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "font-semibold text-2xl md:text-4xl text-black font-poppins leading-snug text-center",
                            children: t('partners')
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-wrap justify-evenly items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: _1
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: _2
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: _3
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: _4
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: _5
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: _6
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: _7
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLanding/* FooterLanding */.m, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal/* AuthModal */.Q, {
                    registration: true,
                    open: authOpen,
                    onClose: function() {
                        return setAuthOpen(false);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ForestValueInquiryModal, {
                    open: inquiryModalOpen,
                    onClose: function() {
                        return setInquiryModalOpen(false);
                    }
                })
            ]
        })
    }));
}
function ForosLanding() {
    var t = (0,esm/* useTranslation */.$G)('landing').t;
    var ref = (0,react.useState)(false), authOpen = ref[0], setAuthOpen = ref[1];
    var ref2 = (0,react.useState)(false), inquiryModalOpen = ref2[0], setInquiryModalOpen = ref2[1];
    var openAuthModal = (0,react.useCallback)(function() {
        return setAuthOpen(true);
    }, [
        setAuthOpen
    ]);
    var openInquiryModal = (0,react.useCallback)(function() {
        return setInquiryModalOpen(true);
    }, [
        setInquiryModalOpen
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {
                    onPrimaryClick: openInquiryModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ForestBookSection, {
                    onClick: openInquiryModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingSection, {
                    onClick: openAuthModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuctionsSection, {
                    onClick: openAuthModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full box-border border-b border-gray-300",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(pages_ContentContainer, {
                        $row: true,
                        className: "py-14 md:py-40",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1 text-center md:text-left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionDesc, {
                                    className: "items-center md:items-start mr-0 md:mr-6 max-w-xl",
                                    icon: grow_green,
                                    sectionTitle: t('growingSection.title'),
                                    title: t('growingSection.heading'),
                                    info: t('growingSection.content'),
                                    onClick: openAuthModal
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden md:flex flex-1 justify-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    objectFit: "contain",
                                    src: portfolio,
                                    width: 560,
                                    height: 377
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SellingSections, {
                    onClick: openAuthModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLanding/* FooterLanding */.m, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal/* AuthModal */.Q, {
                    registration: true,
                    open: authOpen,
                    onClose: function() {
                        return setAuthOpen(false);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ForestValueInquiryModal, {
                    open: inquiryModalOpen,
                    onClose: function() {
                        return setInquiryModalOpen(false);
                    }
                })
            ]
        })
    }));
}
function ForosFILanding() {
    var ref = (0,react.useState)(false), authOpen = ref[0], setAuthOpen = ref[1];
    var ref3 = (0,react.useState)(false), inquiryModalOpen = ref3[0], setInquiryModalOpen = ref3[1];
    var openAuthModal = (0,react.useCallback)(function() {
        return setAuthOpen(true);
    }, [
        setAuthOpen
    ]);
    var openInquiryModal = (0,react.useCallback)(function() {
        return setInquiryModalOpen(true);
    }, [
        setInquiryModalOpen
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {
                    onPrimaryClick: openInquiryModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FIMarketingSection, {
                    onClick: openAuthModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuctionsSection, {
                    onClick: openAuthModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SellingSections, {
                    onClick: openAuthModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLanding/* FooterLanding */.m, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal/* AuthModal */.Q, {
                    registration: true,
                    open: authOpen,
                    onClose: function() {
                        return setAuthOpen(false);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ForestValueInquiryModal, {
                    open: inquiryModalOpen,
                    onClose: function() {
                        return setInquiryModalOpen(false);
                    }
                })
            ]
        })
    }));
}
var Landing = function() {
    switch((domains_default()).current.name){
        case 'foros.fi':
            return ForosFILanding;
        case 'foros.lv':
        case 'miskoaukcionas.lt':
            return ForosLVLanding;
        default:
            return ForosLanding;
    }
};
var __N_SSG = true;
/* harmony default export */ var pages = (Landing());


/***/ }),

/***/ 77652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ActiveTag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  inline-block\n  px-2\n  py-[5px]\n  rounded\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-bold\n  text-xs\n  uppercase\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var TagContainer = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject(), function(param) {
    var $active = param.$active;
    return $active ? 'bg-green-100' : 'bg-red-100';
});
var TagTitle = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default().p(_templateObject1(), function(param) {
    var $active = param.$active;
    return $active ? 'text-green-500 animate-pulse' : 'text-red-500';
});
var ActiveTag = function(_param) {
    var title = _param.title, active = _param.active, props = _objectWithoutProperties(_param, [
        "title",
        "active"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TagContainer, _objectSpread({
        $active: active
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TagTitle, {
            $active: active,
            children: title
        })
    })));
};



/***/ }),

/***/ 699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Countdown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96577);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32345);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75920);
/* harmony import */ var _foros_fe_assets_icons_clock_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96321);







function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "flex flex-1 items-center"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "flex mr-3 min-w-[24px]"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "text-green-500 text-sm"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var Container = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().div(_templateObject());
var ImgContainer = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().div(_templateObject1());
var Text = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().p(_templateObject2());
var Countdown = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var className = param.className, endTime = param.endTime, _showTimestamp = param.showTimestamp, showTimestamp = _showTimestamp === void 0 ? false : _showTimestamp;
    var time = (0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useDateTimeDuration */ .$o)(endTime);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImgContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    src: _foros_fe_assets_icons_clock_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                    width: 24,
                    height: 24
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Text, {
                children: [
                    time,
                    showTimestamp ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "text-gray-700",
                        children: [
                            " [",
                            (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .endTimestamp */ .mE)(endTime),
                            "]"
                        ]
                    }) : null
                ]
            })
        ]
    }));
});


/***/ }),

/***/ 70331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ PhoneInput; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(48090);
// EXTERNAL MODULE: ../../node_modules/tailwind-styled-components/dist/index.js
var dist = __webpack_require__(17471);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63964);
// EXTERNAL MODULE: ../../node_modules/react-phone-input-2/lib/lib.js
var lib = __webpack_require__(84695);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ../core/src/components/ErrorMessages.tsx
var ErrorMessages = __webpack_require__(29371);
// EXTERNAL MODULE: ../core/src/config/theme.js
var theme = __webpack_require__(46487);
var theme_default = /*#__PURE__*/__webpack_require__.n(theme);
;// CONCATENATED MODULE: ../assets/icons/arrow-down.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M4.59 5a.837.837 0 0 0 .581-.245l3.791-3.578a.646.646 0 0 0 .205-.484A.648.648 0 0 0 8.953.2a.735.735 0 0 0-.521-.2c-.2 0-.38.072-.537.215l-3.548 3.37h.486L1.278.214A.777.777 0 0 0 .742 0a.743.743 0 0 0-.528.2A.648.648 0 0 0 0 .693c0 .187.07.348.211.484l3.79 3.578A.84.84 0 0 0 4.59 5Z",
    fill: "#333"
  })));
};

/* harmony default export */ var arrow_down = (SvgArrowDown);
// EXTERNAL MODULE: ../../node_modules/react-phone-input-2/lib/high-res.css
var high_res = __webpack_require__(72497);
;// CONCATENATED MODULE: ../core/src/components/Inputs/PhoneInput.tsx












function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "flex flex-col flex-1 text-left"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex\n  items-center\n  h-10\n  md:h-11\n  border\n  rounded-lg\n  focus-within:border-secondary-500\n  w-full\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  border-color: ",
        ";\n  background-color: ",
        ";\n\n  & .react-tel-input {\n    display: flex;\n    flex: 1;\n\n    & .form-control {\n      display: flex;\n      flex: 1;\n      background: ",
        ";\n      color: ",
        ";\n      border: none;\n      @media only screen and (max-width: 640px) {\n        font-size: 14px;\n      }\n      font-size: 16px;\n      outline: none;\n      padding-left: 74px;\n      padding-right: 12px;\n      width: 100%;\n    }\n\n    & .special-label {\n      display: none;\n    }\n\n    & .flag-dropdown {\n      background: ",
        ";\n      border: none;\n      border-radius: 8px 0 0 8px;\n      padding-top: 5px;\n      padding-bottom: 5px;\n      &:hover,\n      &:focus {\n        cursor: pointer;\n      }\n\n      &.open {\n        z-index: 2;\n      }\n\n      & .selected-flag {\n        outline: none;\n        position: relative;\n        width: 66px;\n        height: 100%;\n        padding: 0 0 0 15px;\n        border-right: 1px solid ",
        ";\n\n        &:focus {\n          .arrow {\n            border-left-width: 4px;\n            border-right-width: 4px;\n          }\n        }\n\n        & .flag {\n          position: absolute;\n          top: 50%;\n          margin-top: -12px;\n        }\n\n        & .arrow {\n          position: relative;\n          top: 52%;\n          margin-top: -1px;\n          left: 30px;\n          width: 10px;\n          height: 5px;\n          background: url('data:image/svg+xml,",
        "');\n          border: none;\n\n          &.up {\n            transform: scaleY(-1);\n            border-top: none;\n          }\n        }\n      }\n    }\n\n    .country-list {\n      outline: none;\n      z-index: 1;\n      list-style: none;\n      position: absolute;\n      padding: 0;\n      margin: 10px 0 10px -1px;\n      box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.35);\n      background-color: ",
        ";\n      width: 300px;\n      overflow-y: scroll;\n      border-radius: 4px;\n\n      .country {\n        padding: 7px 9px 7px 44px;\n        position: relative;\n        color: ",
        ";\n\n        .dial-code {\n          color: ",
        ";\n        }\n\n        &:hover {\n          background-color: ",
        ";\n        }\n\n        &.highlight {\n          background-color: ",
        ";\n\n          &:hover {\n            background-color: ",
        ";\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  text-sm\n  font-semibold\n  mb-1\n  md:mb-2\n  text-gray-800\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var Input = (lib_default());
var svgString = encodeURIComponent((0,server_browser.renderToStaticMarkup)(/*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_down, {})));
var Container = dist_default().div(_templateObject());
var TwContainer = dist_default().div(_templateObject1());
var InputContainer = (0,styled_components_browser_esm/* default */.ZP)(TwContainer).withConfig({
    componentId: "sc-15434409-0"
})(_templateObject2(), function(param) {
    var $error = param.$error;
    return $error ? (theme_default()).colors.red[500] : (theme_default()).colors.gray[400];
}, function(param) {
    var $disabled = param.$disabled;
    return $disabled ? (theme_default()).colors.gray[200] : (theme_default()).colors.white;
}, (theme_default()).colors.white, (theme_default()).colors.gray[800], (theme_default()).colors.white, (theme_default()).colors.gray[400], svgString, (theme_default()).colors.white, (theme_default()).colors.primary[500], (theme_default()).colors.black, (theme_default()).colors.gray[300], (theme_default()).colors.gray[300], (theme_default()).colors.gray[400]);
var Label = dist_default().label(_templateObject3());
var PhoneInput = /*#__PURE__*/ (0,react.forwardRef)(function(_param1, ref5) {
    var label = _param1.label, name = _param1.name, className = _param1.className, disabled = _param1.disabled, error = _param1.error, languageCode = _param1.languageCode, placeholder = _param1.placeholder, onChange = _param1.onChange, value1 = _param1.value, props = _objectWithoutProperties(_param1, [
        "label",
        "name",
        "className",
        "disabled",
        "error",
        "languageCode",
        "placeholder",
        "onChange",
        "value"
    ]);
    var context = (0,index_esm/* useFormContext */.Gc)();
    var inputRef = (0,react.useRef)(null);
    var ref1 = (0,esm/* useTranslation */.$G)('enum'), t = ref1.t, i18n = ref1.i18n;
    var ref2 = (0,react.useState)(null), country1 = ref2[0], setCountry = ref2[1];
    var localization = (0,react.useMemo)(function() {
        return Object.fromEntries(Object.entries(t("CountryCode", {
            returnObjects: true
        })).map(function(param) {
            var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
            return [
                key.toLowerCase(),
                value, 
            ];
        }));
    }, [
        t
    ]);
    var handleChange = (0,react.useCallback)(function(value, country) {
        setCountry(country);
        if ('dialCode' in country && country.dialCode === value) {
            return onChange(null);
        }
        onChange(value);
    }, [
        onChange
    ]);
    (0,react.useImperativeHandle)(ref5, function() {
        return {
            focus: function() {
                var ref, ref4;
                return (ref = inputRef.current) === null || ref === void 0 ? void 0 : (ref4 = ref.numberInputRef) === null || ref4 === void 0 ? void 0 : ref4.focus();
            }
        };
    }, [
        inputRef
    ]);
    var fieldError = error || (0,index_esm/* get */.U2)(context === null || context === void 0 ? void 0 : context.formState.errors, name);
    var ref3;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        className: className,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputContainer, {
                $disabled: disabled,
                $error: fieldError,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, _objectSpread({
                    country: (ref3 = languageCode === null || languageCode === void 0 ? void 0 : languageCode.toLowerCase()) !== null && ref3 !== void 0 ? ref3 : i18n.language,
                    placeholder: placeholder,
                    countryCodeEditable: false,
                    disabled: disabled,
                    ref: inputRef,
                    localization: localization,
                    onChange: handleChange,
                    value: value1 !== null && value1 !== void 0 ? value1 : country1 === null || country1 === void 0 ? void 0 : country1.dialCode
                }, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessages/* ErrorMessages */.X, {
                error: fieldError
            })
        ]
    }));
});



/***/ }),

/***/ 41673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29982);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63964);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46487);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33052);







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex\n  flex-col\n  flex-1\n  text-left\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  & .Select__control {\n    background-color: ",
        ";\n    border-color: ",
        ";\n    display: flex;\n    flex: 1;\n    box-shadow: none !important;\n    height: 44px;\n    border-radius: 8px;\n\n    @media (max-width: 768px) {\n      height: 40px;\n    }\n  }\n\n  & .Select__control--is-focused,\n  & .Select__control--menu-is-open {\n    border-color: ",
        " !important;\n  }\n\n  & .Select__control:hover {\n    background-color: ",
        ";\n    border-color: ",
        ";\n    width: 100%;\n  }\n\n  & .Select__single-value {\n    color: ",
        ";\n  }\n\n  & .Select__placeholder {\n    color: ",
        ";\n  }\n\n  & .Select__indicator-separator {\n    display: none;\n  }\n\n  & .Select__indicator Select__dropdown-indicator {\n    border-color: transparent transparent red;\n  }\n\n  & .Select__menu {\n    z-index: 100;\n  }\n\n  & .Select__option {\n    color: ",
        ";\n\n    & :hover {\n      background-color: ",
        ";\n    }\n  }\n\n  & .Select__option--is-selected {\n    background-color: ",
        ";\n\n    & :hover {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Container = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().div(_templateObject());
var StyledSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(react_select__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP).withConfig({
    componentId: "sc-a70c89b9-0"
})(_templateObject1(), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.white), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.gray[400]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.secondary[500]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.white), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.gray[400]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.gray[800]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.gray[600]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.primary[500]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.gray[300]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.gray[300]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.gray[400]));
var GenericSelect = function(_param, ref1) {
    var label = _param.label, className = _param.className, props = _objectWithoutProperties(_param, [
        "label",
        "className"
    ]);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)('common').t;
    var selectRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref1, function() {
        return {
            focus: function() {
                var ref;
                return (ref = selectRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            }
        };
    }, [
        selectRef
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        className: className,
        children: [
            label ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: "text-sm mb-1 md:mb-2 font-semibold text-gray-800",
                children: label
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSelect, _objectSpread({
                instanceId: label,
                classNamePrefix: "Select",
                isSearchable: false,
                placeholder: t('choose'),
                openMenuOnFocus: true,
                ref: selectRef
            }, props))
        ]
    }));
};
var Select = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(GenericSelect);


/***/ }),

/***/ 17094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ ResponsiveImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75920);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96577);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32345);




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var ResponsiveImage = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .clientOnlyComponent */ .V4)(function(_param) {
    var sizes = _param.sizes, widths = _param.widths, heights = _param.heights, props = _objectWithoutProperties(_param, [
        "sizes",
        "widths",
        "heights"
    ]);
    var mobile = (0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useDeviceMediaQuery */ .mL)().mobile;
    var ref = _slicedToArray(widths !== null && widths !== void 0 ? widths : sizes, 2), mobileWidth = ref[0], desktopWidth = ref[1];
    var ref1 = _slicedToArray(heights !== null && heights !== void 0 ? heights : sizes, 2), mobileHeight = ref1[0], desktopHeight = ref1[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], _objectSpread({}, props, {
        width: mobile ? mobileWidth : desktopWidth,
        height: mobile ? mobileHeight : desktopHeight
    })));
});



/***/ }),

/***/ 77990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ usePaginatedListAuctionsQuery; },
/* harmony export */   "D": function() { return /* binding */ usePaginatedBaseMarketAuctionQuery; }
/* harmony export */ });
/* harmony import */ var _generated__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63575);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33627);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var PER_PAGE = 10;
var usePaginatedListAuctionsQuery = function(variables) {
    return (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .usePaginatedQuery */ .N)(_generated__WEBPACK_IMPORTED_MODULE_1__/* .useListAuctionsQuery */ .e5v, {
        variables: _objectSpread({
            first: PER_PAGE
        }, variables),
        nextFetchPolicy: 'cache-only'
    }, 'auctions');
};
var usePaginatedBaseMarketAuctionQuery = function(variables) {
    return (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .usePaginatedQuery */ .N)(_generated__WEBPACK_IMPORTED_MODULE_1__/* .useBaseMarketAuctionsQuery */ .fSg, {
        variables: _objectSpread({
            first: PER_PAGE
        }, variables),
        fetchPolicy: 'cache-first'
    }, 'marketAuctions');
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,7362,1433,9982,4761,3442,2234,9659,2888,179], function() { return __webpack_exec__(8738); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);